import { QuestionBodySingleSelect } from '@/features/advisor-onboarding/questionnaire/components/question-body-single-select';
import { PartnerConnectionSection } from '@/features/distribution-partners';

import { Check } from 'lucide-react';

import type { AnswerOption, BgaPartnerInterest } from '@shared';

const CONFIRMATION_COPY: Record<BgaPartnerInterest, string> = {
  'connect-with-partners':
    "Our team will reach out today with a list of our current partners to help you find a great fit, and then we'll make a warm introduction for you.",
  'explore-waterlily-bga':
    'Our team will reach out today to confirm your eligibility and help you through the contracting process.',
  'all-set-for-now': "Got it — we'll check in down the road if anything changes.",
};

interface QuestionBodyPartnerInterestProps {
  options: AnswerOption[];
  value: BgaPartnerInterest | null;
  confirmedValue: BgaPartnerInterest | null;
  onSelect: (value: BgaPartnerInterest) => void;
  canSelectPartners?: boolean;
  disabled?: boolean;
}

export function QuestionBodyPartnerInterest({
  options,
  value,
  confirmedValue,
  onSelect,
  canSelectPartners = false,
  disabled,
}: QuestionBodyPartnerInterestProps) {
  // When the advisor wants to connect with our partners, let them pick partners and contacts
  // right here instead of showing a "we'll reach out" confirmation.
  if (confirmedValue === 'connect-with-partners' && canSelectPartners) {
    return <PartnerConnectionSection variant="questionnaire" />;
  }

  if (confirmedValue) {
    return (
      <div className="border-border bg-background flex flex-col items-center gap-4 rounded-lg border p-6 text-center">
        <div className="bg-primary/10 text-primary flex size-10 items-center justify-center rounded-full">
          <Check className="size-5" />
        </div>
        <p className="text-foreground text-sm sm:text-base">{CONFIRMATION_COPY[confirmedValue]}</p>
      </div>
    );
  }

  return (
    <QuestionBodySingleSelect
      options={options}
      value={value}
      onChange={v => onSelect(v as BgaPartnerInterest)}
      disabled={disabled}
    />
  );
}
